import React, { useEffect } from 'react';
import { ThemeProvider, CssBaseline, makeStyles } from '@material-ui/core';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import light from './themes/light';
import Routes from './routes';
import AppContext from './contexts/app.context';
import envConfig from './config/environment-config';

const useStyles = makeStyles({
  app: {
    background: '#fff',
    height: '100vh',
  },
});

function loadGTM(headScript: string, bodyScript: string) {
  if (document.querySelector('script[src*="gtm.js"]')) return;

  if (headScript) {
    const div = document.createElement('div');
    div.innerHTML = headScript;
  
    const script = div.querySelector('script');
    if (!script) return;
  
    const newScript = document.createElement('script');
    newScript.id = 'gtm-script';
    newScript.text = script.innerHTML;
  
    document.head.appendChild(newScript);
  }

  if (bodyScript) {
    const div = document.createElement('div');
    div.innerHTML = bodyScript;
  
    const noscript = div.querySelector('noscript');
    if (!noscript) return;
  
    const wrapper = document.createElement('div');
    wrapper.id = 'gtm-noscript';
    wrapper.innerHTML = noscript.innerHTML;
  
    document.body.prepend(wrapper);
  }
}

async function fetchProgramConfig() {
  try {
    const baseUrl = envConfig.pharmaceuticalPortalApiUrl;
    const url = `${baseUrl}/integration/program-website-config`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error loading program config:', error);
    return null;
  }
}

function App(): JSX.Element {
  const classes = useStyles();

  useEffect(() => {
    async function initGTM() {
      const config = await fetchProgramConfig();
      if (config?.GoogleTagManagerHead || config?.GoogleTagManagerBody) {
        loadGTM(config.GoogleTagManagerHead || '', config.GoogleTagManagerBody || '');
      }
    }
    initGTM();
  }, []);

  return (
    <div className={classes.app}>
      <ThemeProvider theme={light}>
        <ToastContainer
          position="top-center"
          autoClose={false}
          closeOnClick
          draggable
          hideProgressBar
          style={{ top: '40%' }}
          limit={1}
          newestOnTop
        />
        <CssBaseline />
        <AppContext>
          <Routes />
        </AppContext>
      </ThemeProvider>
    </div>
  );
}

export default App;
